import { Component, Injector, OnInit } from '@angular/core';
import { HomeBaseComponent } from './../common-theme/index';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT, IAlbum } from 'angular2-lightbox';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
import { PropertyService } from '../common-theme/api/property.service';
import { Project } from '../common-theme/models/index';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent extends HomeBaseComponent implements OnInit {
  private _albums: IAlbum[];
  private _subscription: Subscription;
  projects: Project[] = [];

  constructor(
    injector: Injector,
    agencyService: AgencyService,
    propertyService: PropertyService,
    openModalService: OpenModalService,
    route: ActivatedRoute,
    private _lightbox: Lightbox,
    private _lightboxEvent: LightboxEvent,
    private _lighboxConfig: LightboxConfig
  ) {
    super(
      injector,
      agencyService,
      route,
      propertyService,
      openModalService
    );
    this.initLightbox([
      '/assets/images/home/about_us_1.webp',
      '/assets/images/home/about_us_2.webp',
      '/assets/images/home/about_us_3.webp'
    ]);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.route.data.forEach((data: { projects: Project[] }) => {
      this.projects = data.projects.filter(project => project.map_plan.url).sort((a, b) => a.name.localeCompare(b.name));
      this.projects.find(project => project.id === 573).map_plan.url = '/assets/images/map_plan/b12.webp';
      this.projects.find(project => project.id === 694).map_plan.url = '/assets/images/map_plan/b11.webp';
      this.projects.find(project => project.id === 933).map_plan.url = '/assets/images/map_plan/b12.webp';
    });

    this.setTitle('Dream Residence: garsoniere, apartamente ieftine de vanzare sector 5');

    this.setMetaDescription(
      `Dream Residence este investitia de lunga durata in tine, familia ta si calitatea vietii tale. Ai la dispozitie un complex rezidential intr-o oferta accesibila.`
    );
  }

  open(index: number): void {
    this._lighboxConfig.positionFromTop = 20;
    this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(event => this._onReceivedEvent(event));
    this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
  }

  private _onReceivedEvent(event: any): void {
    if (event.id === LIGHTBOX_EVENT.CLOSE) {
      this._subscription.unsubscribe();
    }
  }

  initLightbox(images: string[]): void {
    this._albums = [];
    for (const image of images) {
      const album = {
          src: image,
          caption: '', // TODO: add real captions
          thumb: image
      };

      this._albums.push(album);
    }
    this._lighboxConfig.fadeDuration = 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts